import withStyles from '@material-ui/core/styles/withStyles';
import { default as React } from 'react';
import { connect } from 'react-redux';

import * as Score from "utils/Score";
import { MONO } from "./ReportViz";
import pdf from "utils/pdfKit";
import moment from "moment"

import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { downloadXlsx } from "utils/xlsx";
import { t } from 'i18next';
import { withTranslation } from 'react-i18next';

require('assets/fonts/dejavu-sans-ttf-2.34/DejaVuSans-normal.js')
require('assets/fonts/dejavu-sans-ttf-2.34/DejaVuSans-bold.js')


const styles = {};

// Header label for a response row. When the response carries a location tag (from a per-location
// QR), show "<Location> — <guest name>" using the PMS-resolved name, falling back to the email,
// then to just the location. Without a location it keeps the legacy "email or id" behaviour.
function responseHeaderText(r) {
    // Show every identifier we have, in order of usefulness, and never drop the email — it is how
    // the hotel actually contacts the guest. Falls back to the internal id only when nothing else
    // is known (e.g. an anonymous QR answer).
    const parts = [
        r.location ? `${t('Location')} ${r.location}` : '',
        r.guest_name || '',
        r.email || '',
    ].filter(Boolean)
    return parts.length ? parts.join(' — ') : `#${r.responseID}`
}

const report_types = [
    {
        label: t('Analytical'),
        value: "Analytical"
    },
    {
        label: t('Summary'),
        value: "Summary"
    },
    {
        label: t('Text reports'),
        value: "Textreports"
    },
    {
        label: t('Comparation'),
        value: "Comparation"
    }
];
// Respondent card, styled like the reports mockup: a Location chip (when present) + guest/email,
// the score, and a chevron on the right; click the header to expand the question/answer list.
// Opening the full respondent survey moved to a subtle link inside the expanded body.
const ResponseComponent = (props) => {
    const [open, setOpen] = React.useState(false);
    const { response, survey_id, response_id } = props
    const score = Number(response.responseScore || 0)
    // score 0 = no rating question answered at all (the guest only left a comment / text field),
    // which is not the same as a bad score — show it as "no score" instead of a red 0.00.
    const hasScore = score > 0
    const sc = score >= 4 ? '#2f8a45' : (score >= 3.4 ? '#c98a2b' : '#d1495b')
    // Name and email are shown together (name bold, email beside it) so a response is always
    // traceable back to the guest. A response with neither — an anonymous QR answer — is labelled
    // as such instead of exposing the raw internal id.
    const who = response.guest_name || response.email || ''
    const alsoEmail = (response.guest_name && response.email) ? response.email : ''
    return (
        <div style={{ border: '1px solid #e2e8e4', borderRadius: 12, marginBottom: 10, overflow: 'hidden', background: '#fff' }}>
            <div onClick={() => setOpen(!open)}
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, padding: '12px 14px', cursor: 'pointer' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, minWidth: 0 }}>
                    {response.location &&
                        <span style={{ fontFamily: MONO, fontWeight: 700, fontSize: 12, padding: '3px 8px', borderRadius: 6, background: '#e7f4ea', color: '#2f8a45', whiteSpace: 'nowrap' }}>
                            {t('Location')} {response.location}
                        </span>}
                    <span style={{ fontWeight: 600, fontSize: 14, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {who || <span style={{ color: '#8a988f', fontWeight: 500 }}>{t('Anonymous response')}</span>}
                    </span>
                    {alsoEmail &&
                        <span style={{ fontSize: 12.5, color: '#8a988f', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            {alsoEmail}
                        </span>}
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 12, flex: 'none' }}>
                    {hasScore
                        ? <span style={{ fontFamily: MONO, fontWeight: 700, color: sc }}>{score.toFixed(2)}</span>
                        : <span style={{ fontSize: 11.5, fontWeight: 700, padding: '3px 8px', borderRadius: 6, background: '#eef2f0', color: '#8a988f', whiteSpace: 'nowrap' }}>
                            {t('No score')}
                        </span>}
                    <span style={{ color: '#8a988f', display: 'inline-block', transition: 'transform .18s', transform: open ? 'rotate(180deg)' : 'none' }}>▾</span>
                </div>
            </div>
            {open &&
                <div style={{ padding: '0 14px 12px' }}>
                    {(response.answerList || []).map((element, ekey) => (
                        <div key={ekey} style={{ padding: '10px 0', borderTop: '1px solid #eef2f0' }}>
                            <div style={{ fontSize: 12, color: '#8a988f', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '.04em' }}>{element.questionTitle}</div>
                            <div style={{ fontSize: 14, marginTop: 3 }}>{element.answerLabel}</div>
                        </div>
                    ))}
                    <div style={{ marginTop: 10 }}>
                        <a onClick={(e) => { e.stopPropagation(); const win = window.open(`/public/survey_answer/${survey_id}/${response_id}`, '_blank'); if (win) win.focus(); }}
                            style={{ fontSize: 12, color: '#3b6fd4', cursor: 'pointer', textDecoration: 'underline', fontWeight: 600 }}>
                            {t("OPEN RESPONDENT'S SURVEY")} ↗
                        </a>
                    </div>
                </div>}
        </div>
    )
}
class TextReport extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            search: '',
            hideUnrated: false,   // hide responses that answered no rating question at all
            filterData: this.props.filterData,
            surveyQuestion: this.props.surveyQuestion,
            surveyResponses: this.props.surveyResponses,
            surveyMain: this.props.surveyMain,
            reportData: null
        }
    }


    componentDidMount() {
        this.props.onRef(this)
        this.initData()
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.time !== this.props.time) {
            this.initData()
        }
    }

    initData = () => {
        const { filterData, surveyQuestion, surveyResponses, surveyMain } = this.props
        const data = this.calculateData(surveyQuestion, surveyResponses)
        this.setState({

            filterData: filterData,
            surveyQuestion: surveyQuestion,
            surveyResponses: surveyResponses,
            surveyMain: surveyMain,
            reportData: data
        })
    }

    getEmailsFromGroup = (group) => {
        const emaillist = this.state.emaillist

        const filtered = emaillist.filter(item => item.id === group.value)
        if (filtered && filtered[0]) {
            return filtered[0].emails
        } else {
            return []
        }
    }
    // Respondents honouring the current search box — same filter the on-screen list and the
    // compact print HTML use, so the PDF matches what the user is looking at.
    filteredRespondents = () => {
        let data = this.calculateData(this.props.surveyQuestion, this.props.surveyResponses) || []
        const s = (this.state.search || '').trim().toLowerCase()
        if (s) {
            data = data.filter(r => {
                const parts = [r.location, r.guest_name, r.email]
                    ;(r.answerList || []).forEach(a => { parts.push(a.answerLabel); parts.push(a.questionTitle) })
                return parts.filter(Boolean).join(' ').toLowerCase().indexOf(s) >= 0
            })
        }
        if (this.state.hideUnrated) data = data.filter(r => r.responseScore > 0)
        return data
    }

    // Modern Text-report PDF (shared pdfKit look): green header band, a filters caption, then one
    // card per respondent — a light-green header strip with "N. Location — guest" and a
    // colour-coded score, followed by a borderless zebra Q/A table. Worst score first.
    generatePdf = (fileName) => {
        const doc = new jsPDF();
        const W = doc.internal.pageSize.getWidth();
        const H = doc.internal.pageSize.getHeight();
        const bottom = H - 14;

        const { filterData, surveyMain } = this.props
        const isCompare = filterData.type.value === report_types[3].value
        const period1 = String(moment(filterData.from1).format('LL') + ' ~ ' + moment(filterData.to1).format('LL'))
        const period2 = String(moment(filterData.from2).format('LL') + ' ~ ' + moment(filterData.to2).format('LL'))

        let y = pdf.header(doc, {
            title: surveyMain.title,
            subtitle: isCompare ? period1 + '   |   ' + period2 : period1,
            right: t('Text reports'),
        })

        // filters caption — only the parts that are actually set, in one soft grey line
        const emailGroup = filterData.group.map(a => a.label).join(', ')
        const section = filterData.section ? filterData.section.label : ''
        const question = filterData.question ? filterData.question.label : ''
        const answer = filterData.answer.map(a => a.label).join(', ')
        const capParts = []
        if (emailGroup) capParts.push(t('Emails Group') + ': ' + emailGroup)
        if (section) capParts.push(t('Section') + ': ' + section)
        if (question) capParts.push(t('Question') + ': ' + question)
        if (answer) capParts.push(t('Answers') + ': ' + answer)
        if (capParts.length) {
            doc.setFont('DejaVuSans', 'normal'); doc.setFontSize(8.5)
            doc.setTextColor(pdf.SOFT[0], pdf.SOFT[1], pdf.SOFT[2])
            const capLines = doc.splitTextToSize(capParts.join('    •    '), W - 24)
            doc.text(capLines, 12, y)
            y += capLines.length * 4 + 1.5
        }

        const rows = this.filteredRespondents()
        doc.setFont('DejaVuSans', 'normal'); doc.setFontSize(8)
        doc.setTextColor(pdf.FAINT[0], pdf.FAINT[1], pdf.FAINT[2])
        doc.text(`${t('Total Answers')}: ${rows.length}    ↑ ${t('Sorted worst score first — the responses that need attention are at the top.')}`,
            12, y, { maxWidth: W - 24 })
        y += 6

        const bandH = 9
        rows.forEach((response, key) => {
            // keep the header band with at least a couple of Q/A lines together
            if (y + bandH + 14 > bottom) { doc.addPage(); pdf.topStrip(doc); y = 16 }

            // light-green header strip: "N. Location — guest"  ......  colour-coded score
            doc.setFillColor(pdf.SEC_FILL[0], pdf.SEC_FILL[1], pdf.SEC_FILL[2])
            doc.roundedRect(12, y, W - 24, bandH, 1.5, 1.5, 'F')
            doc.setFont('DejaVuSans', 'bold'); doc.setFontSize(9)
            doc.setTextColor(pdf.INK[0], pdf.INK[1], pdf.INK[2])
            const label = `${key + 1}. ${responseHeaderText(response)}`
            doc.text(doc.splitTextToSize(label, W - 60)[0], 15, y + 6)
            // score 0 = no rating answered at all — print "no score" instead of a red 0.00
            const hasScore = response.responseScore > 0
            const sc = hasScore ? pdf.scoreColor(response.responseScore, 5) : pdf.FAINT
            doc.setTextColor(sc[0], sc[1], sc[2])
            doc.text(hasScore ? Number(response.responseScore).toFixed(2) : t('No score'), W - 15, y + 6, { align: 'right' })
            y += bandH

            const body = (response.answerList || []).map(el => [el.questionTitle, el.answerLabel])
            if (!body.length) body.push([{ content: t('No answers'), colSpan: 2, styles: { textColor: pdf.FAINT, halign: 'center', fontStyle: 'italic' } }])
            doc.autoTable(pdf.modernOptions({
                startY: y,
                body,
                columnStyles: {
                    0: { cellWidth: (W - 24) * 0.42, textColor: pdf.SOFT, fontStyle: 'bold' },
                    1: { textColor: pdf.INK },
                },
            }))
            y = doc.previousAutoTable.finalY + 5
        })

        if (!rows.length) {
            doc.setFont('DejaVuSans', 'normal'); doc.setFontSize(10)
            doc.setTextColor(pdf.FAINT[0], pdf.FAINT[1], pdf.FAINT[2])
            doc.text(t('No respondents match') + ' “' + (this.state.search || '') + '”.', 12, y + 4)
        }

        pdf.footer(doc)
        doc.save(fileName)
    }

    generateCSV = () => {

        var rows = [];
        const { filterData, surveyQuestion, surveyResponses, surveyMain } = this.props
        const isCompare = filterData.type.value === report_types[3].value
        const period1 = String(moment(filterData.from1).format('LL') + ' ~ ' + moment(filterData.to1).format('LL'))
        const period2 = String(moment(filterData.from2).format('LL') + ' ~ ' + moment(filterData.to2).format('LL'))
        const emailGroup = filterData.group.map(a => a.label).join(',');
        const section = filterData.section ? filterData.section.label : '';
        const question = filterData.question ? filterData.question.label : '';
        const answer = filterData.answer.map(a => a.label).join(',');

        rows.push([t('Filter options')])
        rows.push([
            t('Period1'),
            t('Emails Group'),
            t('Section'),
            t('Question'),
            t('Answers'),
        ])
        rows.push([period1, emailGroup, section, question, answer])

        const surveydata = this.calculateData(surveyQuestion, surveyResponses)
        surveydata.map((response, key) => {

            rows.push([t('Response') + ` ${key + 1}`]);
            rows.push([t('Question'), t('Answer')])
            response.answerList.forEach((element, ekey) => {

                const questionTitle = element.questionTitle
                const answerLabel = element.answerLabel
                rows.push([questionTitle, answerLabel])

            })

        });

        let csvContent = "data:text/csv;charset=utf-8,"
            + rows.map(e => e.join(",")).join("\n");
        var encodedUri = encodeURI(csvContent);
        window.open(encodedUri);
    }

    // Excel export of the Text report — one block per respondent (worst score first), with the
    // Location — guest header and a numeric score, then their question/answer pairs.
    generateExcel = (fileName) => {
        const { surveyQuestion, surveyResponses } = this.props
        const surveydata = this.calculateData(surveyQuestion, surveyResponses)
        const rows = []
        surveydata.forEach((response, key) => {
            // leave the score cell empty when the guest answered no rating question (0 = no score)
            rows.push([`${t('Response')} ${key + 1}`, responseHeaderText(response),
                response.responseScore > 0 ? Number(response.responseScore.toFixed(2)) : ''])
            rows.push([t('Question'), t('Answer')])
            response.answerList.forEach(element => rows.push([element.questionTitle, element.answerLabel]))
            rows.push([])
        })
        downloadXlsx([{ name: 'Text reports', rows }], fileName)
    }
    // Compact, self-contained HTML for printing — one tight block per respondent
    // (Location — guest · score, then question/answer pairs), worst score first, honouring the
    // current search filter. No MUI accordions, no "open survey" link, minimal whitespace, so a
    // large survey prints in a fraction of the pages the on-screen accordion view would take.
    getPrintHtml = () => {
        const esc = (v) => String(v == null ? '' : v).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        const filtered = this.filteredRespondents()
        if (!filtered.length) return '<div style="font-size:13px;color:#8a988f;">' + esc(t('No respondents match')) + ' “' + esc(this.state.search) + '”.</div>'
        const blk = 'border:1px solid #e2e8e4;border-radius:8px;padding:7px 10px;margin:0 0 7px;page-break-inside:avoid;'
        return filtered.map((r, i) => {
            const hasScore = r.responseScore > 0
            const sc = hasScore ? (r.responseScore >= 4 ? '#2f8a45' : (r.responseScore >= 3.4 ? '#c98a2b' : '#d1495b')) : '#8a988f'
            const scoreTxt = hasScore ? r.responseScore.toFixed(2) : esc(t('No score'))
            const head = '<div style="display:flex;justify-content:space-between;gap:10px;font-weight:700;font-size:13px;margin-bottom:3px;">' +
                '<span>' + (i + 1) + '. ' + esc(responseHeaderText(r)) + '</span>' +
                '<span style="color:' + sc + ';font-variant-numeric:tabular-nums;">' + scoreTxt + '</span></div>'
            const qas = (r.answerList || []).map(el =>
                '<div style="font-size:12px;margin:2px 0;line-height:1.4;"><span style="color:#8a988f;">' + esc(el.questionTitle) + ':</span> ' + esc(el.answerLabel) + '</div>'
            ).join('')
            return '<div style="' + blk + '">' + head + qas + '</div>'
        }).join('')
    }

    calculateData = (filterQuestion, filterResponses) => {

        if (filterQuestion.sections.length === 0) return null


        let result = []
        filterResponses.map((response) => {
            const answers = response.answers
            let answerList = []
            filterQuestion.sections.map((section) => {
                section.questions.map((question) => {
                    if (Score.VALUETYPE === question.question.type) return null;
                    const questionTitle = question.questionTitle
                    const answer = answers.filter(a => a.id === question.id)[0]
                    if (!answer) return null
                    const answerLabel = Score.getLabelOfAnswerValue(question, answer.value)
                    answerList.push({
                        questionTitle,
                        answerLabel
                    })
                })
            })
            const responseScore = Score.getScoreOfOneResponse(filterQuestion, answers)
            result.push({
                responseID: response.id,
                email: response.email,
                location: response.location,
                guest_name: response.guest_name,
                answerList,
                responseScore: responseScore
            })
        })
        // Worst score first — the responses that need attention lead, the best ones close the list.
        // A score of 0 means "no rating question was answered" (not "worst"), so those responses
        // are pushed to the END: they'd otherwise crowd the top and hide the genuinely low scores.
        // They are kept, because they usually carry a comment or a room/date text answer.
        result.sort((a, b) => {
            const aNone = !(a.responseScore > 0), bNone = !(b.responseScore > 0)
            if (aNone !== bNone) return aNone ? 1 : -1
            return a.responseScore - b.responseScore
        })
        return result
    }


    renderTextReport = (data) => {
        if (!data) return null

        const s = (this.state.search || '').trim().toLowerCase()
        let filtered = s ? data.filter(r => {
            const parts = [r.location, r.guest_name, r.email]
            ;(r.answerList || []).forEach(a => { parts.push(a.answerLabel); parts.push(a.questionTitle) })
            return parts.filter(Boolean).join(' ').toLowerCase().indexOf(s) >= 0
        }) : data
        if (this.state.hideUnrated) filtered = filtered.filter(r => r.responseScore > 0)

        if (filtered.length === 0) {
            return <div style={{ fontSize: 13, color: '#8a988f', padding: '12px 4px' }}>{t('No respondents match')} “{this.state.search}”.</div>
        }

        return filtered.map((response, pkey) => (
            <ResponseComponent key={pkey} response={response}
                survey_id={this.props.survey_id} response_id={response.responseID} />
        ))
    }

    render() {

        const { reportData, surveyQuestion } = this.state
        if (!reportData) return '...'

        return <div>
            <input
                value={this.state.search}
                onChange={e => this.setState({ search: e.target.value })}
                placeholder={t('Search by location, name, email or answer text…')}
                style={{
                    width: '100%', fontFamily: 'inherit', fontSize: 14, padding: '10px 12px',
                    border: '1px solid #cfd8d3', borderRadius: 10, background: '#fff', color: '#1b2320', marginBottom: 12,
                }}
            />
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap', margin: '0 2px 12px' }}>
                <div style={{ fontSize: 12, color: '#8a988f' }}>
                    ↑ {t('Sorted worst score first — the responses that need attention are at the top.')}
                </div>
                {(() => {
                    const unrated = (reportData || []).filter(r => !(r.responseScore > 0)).length
                    if (!unrated) return null
                    return (
                        <label style={{ display: 'inline-flex', alignItems: 'center', gap: 7, fontSize: 12.5, color: '#5d6d66', fontWeight: 600, cursor: 'pointer' }}>
                            <input type="checkbox" checked={this.state.hideUnrated}
                                onChange={e => this.setState({ hideUnrated: e.target.checked })} />
                            {t('Hide responses with no score')} ({unrated})
                        </label>
                    )
                })()}
            </div>
            {this.renderTextReport(reportData)}
        </div>;
    }
}
const mapStatsToProps = ({ user }) => ({ user });
export default connect(mapStatsToProps)(
    withTranslation()(withStyles(styles, { withTheme: true })(TextReport))
);